module.exports = __webpack_public_path__ + "static/media/v5-chrome-extensions.64955eb6.gif";